import {Generic_Call, GetSeferData}   from "SeferPetach/GetData";

export async function getOrderByCode(order_code){
    let call = {
        "endpoint": "of19",
        "content": {
            "args": {'ORDER_CODE': order_code}
        }
    };
    let payload = await Generic_Call(call);
    return (payload);
}
export async function getOrderPreviewByCode(order_code){
    var payload = await GetSeferData("of7", {'ORDER_CODE': order_code});
    return (payload);
}
export async function answerOrder(obj){
    let payload = await Generic_Call({endpoint: "of8",
                                      content: {
                                        args: {...obj}}
                                    });
    return (payload);
}

